import React, { CSSProperties, ReactNode, useEffect } from 'react'
import { InputAdornment, TextField } from '@mui/material'
import { useDebouncedCallback } from 'use-debounce'
import { MagnifyingGlassIcon } from '@phosphor-icons/react'
import { tokens } from 'ComponentLibrary/style-dictionary/output'

/** @deprecated Use the Piazza SearchBar component instead. */
export type SearchFieldProps = {
    handleSearch: (searchField: string) => void
    onChange?: (searchField: string) => void
    label?: string
    defaultValue?: string
    className?: string
    debounceDelay?: number
    size?: 'small' | 'medium'
    fullWidth?: boolean
    style?: CSSProperties
    disabled?: boolean
    endAdornment?: ReactNode
}

/** @deprecated Use the Piazza SearchBar component instead. */
const SearchField = ({
    handleSearch,
    onChange,
    className,
    label = 'Suchen',
    debounceDelay = 400,
    size = 'small',
    fullWidth = false,
    style,
    defaultValue = '',
    disabled,
    endAdornment,
}: SearchFieldProps) => {
    const [inputValue, setInputValue] = React.useState(defaultValue)

    useEffect(() => {
        if (!defaultValue) {
            setInputValue('')
        }
    }, [defaultValue])

    const debouncedHandleSearch = useDebouncedCallback(handleSearch, debounceDelay)
    const onChangeHandler = ({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(value)
        onChange?.(value)
        debouncedHandleSearch(value)
    }

    return (
        <TextField
            className={className}
            label={label}
            style={style}
            InputProps={{
                type: 'search',
                endAdornment: (
                    <InputAdornment position="end">
                        {endAdornment ?? <MagnifyingGlassIcon size={tokens.SizingIconM} color={tokens.ColorIconSubtle} />}
                    </InputAdornment>
                ),
            }}
            size={size}
            onChange={onChangeHandler}
            value={inputValue}
            fullWidth={fullWidth}
            disabled={disabled}
        />
    )
}

export default SearchField
